<template>
  <form class="contact-form-1" action="" @submit.prevent="senddata">
    <div class="form-group">
      <input type="text" v-model="dataname" name="fullname" :placeholder="$t('Contact.form.name')" required />
    </div>

    <div class="form-group">
      <input type="email" v-model="dataemail" name="email" :placeholder="$t('Contact.form.email')" required />
    </div>

    <div class="form-group">
      <input type="text" v-model="dataphone" name="phone" :placeholder="$t('Contact.form.phone')" required />
    </div>

    <div class="form-group">
      <input type="text" v-model="datasubject" name="subject" :placeholder="$t('Contact.form.subject')" required />
    </div>

    <div class="form-group">
      <textarea name="message" v-model="datamessage" :placeholder="$t('Contact.form.message')" required>
      </textarea>
    </div>

    <div class="form-group">
      <button type="submit" class="btn-default btn-large">{{ $t('Contact.form.submit') }}</button>
    </div>

    <p v-if="showResult" class="text-success mt--10">
      {{ $t('Contact.form.success', { email: contactEmail }) }}
    </p>
    <p v-if="showError" class="text-danger mt--10">{{ $t('Contact.form.error') }}</p>
  </form>
</template>

<script>
const CONTACT_EMAIL = 'evangelist@gridwhiz.io'

export default {
  name: 'ContactForm',
  data() {
    return {
      contactEmail: CONTACT_EMAIL,
      dataname: '',
      dataemail: '',
      dataphone: '',
      datasubject: '',
      datamessage: '',
      showResult: false,
      showError: false
    }
  },
  methods: {
    senddata() {
      const requiredFields = [
        this.dataname,
        this.dataemail,
        this.dataphone,
        this.datasubject,
        this.datamessage
      ]

      if (requiredFields.every((field) => !!field)) {
        const body = [
          `Name: ${this.dataname}`,
          `Email: ${this.dataemail}`,
          `Phone: ${this.dataphone}`,
          '',
          this.datamessage
        ].join('\n')
        window.location.href =
          `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(this.datasubject)}` +
          `&body=${encodeURIComponent(body)}`
        this.showResult = true
        this.showError = false
      } else {
        this.showError = true
        this.showResult = false
      }
    }
  }
}
</script>
